module.exports = __webpack_public_path__ + "img/m-wash4-back.87743e0f.jpg";